import React from 'react';
import { Box, Icon, Tooltip } from '@mui/material';

import neighbourhoodIcon from '../../../assets/neighbourhood.png';
import neighbourhoodIconToggled from '../../../assets/neighbourhoodToggled.png';

export const NeighbourhoodToggleBtn = ({
  isToggled,
  setNeighbourhoodToggle,
  setManualNeighbourhoodToggle,
}) => {
  const toggleNeighbourhood = () => {
    setManualNeighbourhoodToggle(value => !value);
    setNeighbourhoodToggle(value => !value);
  };

  return (
    <Box
      sx={{
        background: '#fff',
        padding: '5px 5px',
        position: 'absolute',
        bottom: '210px',
        left: '10px',
        zIndex: 3,
        cursor: 'pointer',
      }}
    >
      <Tooltip title={'Neighbourhood Analysis'}>
        {isToggled ? (
          <img
            src={neighbourhoodIconToggled}
            style={{ width: '20px', height: '20px' }}
            onClick={toggleNeighbourhood}
          />
        ) : (
          <img
            src={neighbourhoodIcon}
            style={{ width: '20px', height: '20px' }}
            onClick={toggleNeighbourhood}
          />
        )}
      </Tooltip>
    </Box>
  );
};
